import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesFilmCamrea: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 9.905H32v12.19h-1.53Zm-7.62 12.19h7.62v1.52h-7.62Zm4.57-10.67h1.53v1.53h-1.53Zm-3.04 0h1.52v1.53h-1.52Zm-3.05 12.19h1.52v1.53h-1.52Zm0-12.19h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M1.52 29.715h13.71V28.2h1.53v-1.53h4.57v-1.52h-4.57V9.9h13.71V8.385H16.76v-1.53h-1.53v-1.52h-3.04v-3.05H4.57v3.05H1.52v1.52H0V28.2h1.52Zm4.57-25.9h4.57v1.52H6.09Zm-4.57 19.8h3.05V22.1H1.52v-9.14h3.05v-1.53H1.52V9.9h13.71v15.24H1.52Z\"/><path fill=\"currentColor\" d=\"M18.28 22.095h1.52v1.52h-1.52Zm0-10.67h1.52v1.53h-1.52Zm-6.09 4.58h1.52v7.61h-1.52Zm0-4.58h1.52v1.53h-1.52Zm-3.05 9.15h1.52v3.04H9.14Zm-4.57-7.62h1.52v9.14H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesFilmCamrea
